import { httpsCallable } from 'firebase/functions';

import { AssignablePermission } from 'types/user';

import { functions } from 'clients/firebase';

export const createMuxUpload = httpsCallable<
  { storyId: string; fileName: string },
  { fireStoreId: string; muxUploadUrl: string; muxUploadId: string }
>(functions, 'createMuxUpload');

export const createMultipleChoiceQuestion = httpsCallable<
  { storyId: string },
  { questionId: string }
>(functions, 'createMultipleChoiceQuestion');

export const createChecklist = httpsCallable<
  { storyId: string },
  { checklistId: string }
>(functions, 'createChecklist');

export const createPoll = httpsCallable<
  { storyId: string },
  { pollId: string }
>(functions, 'createPoll');

export const createOpenQuestion = httpsCallable<
  { storyId: string },
  { questionId: string }
>(functions, 'createOpenQuestion');

export const duplicateMedia = httpsCallable<
  { itemPath: string; newItemPath: string },
  { fileUrl: string }
>(functions, 'duplicateMedia');

export const duplicateVideo = httpsCallable<{
  fireStoreId: string;
  muxPlaybackId: string;
  muxAssetId: string;
}>(functions, 'duplicateVideo');

export const sendRegisterMails = httpsCallable<{
  companyId: string;
  emails: string[];
}>(functions, 'sendRegisterMails');

export const updateUserPermissions = httpsCallable<
  { userId: string; permissions: AssignablePermission[] },
  { success: true }
>(functions, 'updateUserPermissions');

export const deactivateUser = httpsCallable<{ userId: string }, void>(
  functions,
  'deactivateUser',
);
